import { combineReducers } from 'redux'

import { SIGN_OUT_SUCCESS } from 'modules/auth'
import {
  EMPTY_QUEUES_LIST,
  RESET_QUEUE_PAGE,
  SET_QUEUE_PAGE,
  SET_QUEUE_PAGE_MONTH,
  SET_QUEUE_PAGE_YEAR,
} from '../action-types'


const defaultPaginationState = { year: null, month: null };
const activePageReducer = (state = defaultPaginationState, action) => {
  switch (action.type) {
    case SET_QUEUE_PAGE:
    case SET_QUEUE_PAGE_YEAR:
    case SET_QUEUE_PAGE_MONTH:
      return {
        year: action.payload.year || state.year,
        month: action.payload.month >= 0 ? action.payload.month : state.month,
      }

    case RESET_QUEUE_PAGE:
    case SIGN_OUT_SUCCESS:
    case EMPTY_QUEUES_LIST:
      return defaultPaginationState

    default:
      return state
  }
}

export default combineReducers({
  activePage: activePageReducer,
})



// WEBPACK FOOTER //
// ./src/modules/queues/reducers/queuesPagination.js